import React from 'react';
import { useI18n } from '../../contexts/I18n';
import { WEEKS, DAY_TO_I18N } from './utils';

export default function DayPicker({ avail, daySel, onToggleDay, onSelectDay }) {
  const { t } = useI18n();
  return (
    <div className="option-group">
      {WEEKS.map((d) => (
        <span
          key={d}
          className={`option ${avail[d] ? 'selected' : ''} ${daySel === d ? 'active' : ''}`}
          onClick={() => (avail[d] ? onSelectDay(d) : onToggleDay(d))}
          onContextMenu={(e) => {
            e.preventDefault();
            onToggleDay(d);
          }}
        >
          {t(DAY_TO_I18N[d] || d)}
        </span>
      ))}
      <small className="hint">{t('ownerDayPickerHint')}</small>
    </div>
  );
}
